import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import logService from "../services/logging/logService";
import LoggerInitializer from "../components/LoggerInitializer";
import PrivateRoute from "../utils/PrivateRoute";
import logoLight from '../assets/images/logo_light.png';
import logoDark from '../assets/images/logo_dark.png';
import { io, Socket } from "socket.io-client";
import { connect } from "react-redux";
import classNames from "classnames";
import { ToastContainer, toast } from "react-toastify";
import { getAuthUrl } from '../config/auth';
import Navbar from "../components/Navbar";

function LinearLayout({ theme }) {
    const notificationsBar = useRef(null);
    const notificationsContainer = useRef(null);
    const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
    const [notifications, setNotifications] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [bgUrl, setBgUrl] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    
    // Registra il cambiamento di pagina
    useEffect(() => {
        const currentPath = location.pathname;
        const pageNameWithoutDashes = currentPath.split('/').pop()?.replace(/-/g, ' ') || '';
        const pageName = pageNameWithoutDashes.replace(/\b\w/g, (c) => c.toUpperCase());
        
        // Log della navigazione
        if (localStorage.getItem('token')) {
            logService.logNavigation(
                currentPath,
                `Visitata pagina: ${pageName || currentPath}`,
                { 
                    title: pageName,
                    path: currentPath,
                    search: location.search,
                    hash: location.hash
                }
            );
            console.log(`Navigazione registrata: ${currentPath}`);
        }
    }, [location.pathname, location.search]);

    const socketRef = useRef<Socket | null>(null);
    const [socketConnected, setSocketConnected] = useState(false);

    const fetchNotifications = useCallback(async (pageNumber: number) => {
        if (loading) return;
        
        const token = localStorage.getItem('token');
        if (!token) {
            return;
        }

/*         setLoading(true);
        try {
            const searchParams = new URLSearchParams();
            searchParams.append('page', pageNumber.toString());
            searchParams.append('limit', '4');  // Richiedi 4 notifiche per pagina
    
            const request = await fetch(`/api/v1/notifications?${searchParams.toString()}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (request.status === 401 || request.status === 403 || request.status === 500) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                navigate(getAuthUrl());
                return;
              }
        

            const response = await request.json();
    
            if (response.data) {
                setNotifications(prev => {
                    const newNotifications = response.data.notifications.filter(
                        newNotif => !prev.some(existingNotif => existingNotif.id === newNotif.id)
                    );
                    return pageNumber === 0 ? newNotifications : [...prev, ...newNotifications];
                });
                if (pageNumber === 0) {
                    setUnreadNotificationsCount(response.data.unreadNotificationsCount[0].count);
                }
                setHasMore(response.data.notifications.length === 4);
                setPage(pageNumber);
            }
        } catch (e) {
            console.error("Error fetching notifications:", e);
        } finally {
            setLoading(false);
        } */
    }, []);


/*     const handleNewNotification = useCallback((notification) => {
       
        setUnreadNotificationsCount(prevCount => prevCount + 1);  // Incrementa il conteggio
        setNotifications(prev => {
            const exists = prev.some(n => n.id === notification.id);
            if (!exists) {
                toast.info(`${notification.payload?.title} - ${notification.payload?.description}`);
                return [notification, ...prev];
            }
            return prev;
        });
    }, []); */

/*     const connectSocket = useCallback(() => {
       
        if (socketRef.current) {
          
            socketRef.current.disconnect();
        }

        const token = localStorage.getItem('token');
     //   console.log('Token for Socket.IO connection:', token ? 'Present' : 'Missing');

        socketRef.current = io("http://localhost:3000", {
            path: '/socket.io',
            query: { token },
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            timeout: 20000,
            transports: ['websocket']
        });

        socketRef.current.on('connect', () => {
            console.log('Connected to Socket.IO server');
            setSocketConnected(true);
        });

        socketRef.current.on('disconnect', (reason) => {
            console.log('Disconnected from Socket.IO server. Reason:', reason);
            setSocketConnected(false);
        });

        socketRef.current.on('connect_error', (error) => {
            console.error('Socket.IO connection error:', error.message);
        });

        socketRef.current.on('notifications', handleNewNotification);
    }, [handleNewNotification]); */

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            console.log('No token found in localStorage');
            navigate(getAuthUrl());
        } else {
            console.log('Token found in localStorage');
        }
    }, []);



    useEffect(() => {
  /*       const bg = new URL(`../assets/images/${theme === 'dark' ? 'bg_desktop.png' : 'bg_desktop_light.jpeg'}`, import.meta.url).href;
        setBgUrl(bg); */
    }, [theme]);


/*     useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            connectSocket();
            fetchNotifications(0);
        }
        return () => {
            if (socketRef.current) {
                socketRef.current.off('notifications');
                socketRef.current.disconnect();
            }
        };
    }, [connectSocket, fetchNotifications]); */




    const handleScroll = (e) => {
        const { target } = e;
        const { scrollTop, scrollHeight, offsetHeight } = target;

        if (scrollTop + offsetHeight >= scrollHeight - 20 && !loading && hasMore) {
            fetchNotifications(page + 1);
        }
    };



    useEffect(() => {
        const currentContainer = notificationsContainer.current;
        if (currentContainer) {
            currentContainer.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (currentContainer) {
                currentContainer.removeEventListener('scroll', handleScroll);
            }
        };
    }, [handleScroll]);


/* const markAllAsRead = async (e) => {
    e.preventDefault();
    try {
        const request = await fetch(`/api/v1/notifications/read`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        await request.json();
        setNotifications(prev => prev.map(n => ({ ...n, read: true })));
        setUnreadNotificationsCount(0);
    } catch (e) {
        console.error("Error marking notifications as read:", e);
    }
}; */

    return (
        <PrivateRoute>
            <LoggerInitializer />
            <div className="min-h-screen h-full bg-contain font-body text-neutral-600 dark:text-white" style={{ backgroundImage: `url(${bgUrl})` }}>
                <div className="min-h-screen bg-white/85 dark:bg-black/15" style={{ height: "100vh" }}>
                    <header className="flex flex-wrap sm:justify-start sm:flex-nowrap z-50 w-full text-sm sm:bg-transparent">
                        <nav className="mx-auto w-full pl-2 sm:pl-0 sm:flex sm:items-center sm:justify-between" aria-label="Global">
                            <div className="flex items-stretch justify-between w-full">
                                <Link className="flex-none" to="/">
                                    <img className="w-[225px] h-auto object-fit" src={theme === 'dark' ? logoDark : logoLight} alt="CEDI" />
                                </Link>
                                <Navbar pageTitle={undefined} />
                          {/*       <div className="flex items-center px-5">
                                    <div className="hs-dropdown relative group max-w-[85rem] w-full" data-hs-dropdown-auto-close="inside">
                                        <div className="hs-dropdown-backdrop bg-black/75 fixed top-0 left-0 right-0 bottom-0"></div>
                                        <a className="hs-dropdown-toggle flex flex-col items-stretch font-medium text-blue-500" href="#" aria-current="page">
                                            <span className="relative">
                                                <span className="text-3xl mb-1 w-full text-neutral-400 dark:text-neutral-200 material-symbols-outlined">notifications</span>
                                                {unreadNotificationsCount > 0 && (
                                                    <svg className="absolute top-0 right-0 w-3 h-3 text-red-500" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="50" cy="50" r="50" />
                                                    </svg>
                                                )}
                                            </span>
                                        </a>
                                        <div id="notifications-menu" className="hs-dropdown-menu transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-60 w-full sm:w-auto sm:max-w-84 shadow-md rounded-lg mt-5 overflow-hidden">
                                            <div className="bg-gray-100 dark:bg-gray-800 p-4 flex justify-between items-center rounded-t-lg">
                                                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Notifiche</h3>
                                                <button onClick={markAllAsRead} className="text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300">
                                                    Segna Tutti
                                                </button>
                                            </div>
                                            <div ref={notificationsBar} onScroll={handleScroll} className="overflow-y-auto max-h-[275px] bg-white dark:bg-gray-700">
                                                {notifications.map((n, i) => (
                                                    <div key={i} className={classNames("relative cursor-pointer flex items-center py-4 px-5 border-b border-gray-200 dark:border-gray-600", {
                                                        "bg-blue-50 dark:bg-blue-900": !n.read,
                                                        "bg-white dark:bg-gray-700": n.read
                                                    })}>
                                                        <div className="flex items-center h-5">
                                                            <span className={classNames("material-symbols-outlined text-2xl", {
                                                                "text-blue-500 dark:text-blue-400": !n.read,
                                                                "text-gray-400 dark:text-gray-500": n.read
                                                            })}>{n.payload.icon}</span>
                                                        </div>
                                                        <div className="ms-3.5">
                                                            <span className={classNames("block text-sm font-semibold", {
                                                                "text-blue-600 dark:text-blue-300": !n.read,
                                                                "text-gray-800 dark:text-gray-200": n.read
                                                            })}>{n.payload.title}</span>
                                                            <span className={classNames("block text-sm", {
                                                                "text-blue-600 dark:text-blue-300": !n.read,
                                                                "text-gray-600 dark:text-gray-300": n.read
                                                            })}>{n.payload.description}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                                {loading && <div className="text-center py-5">Loading...</div>}
                                                {!hasMore && notifications.length > 0 && <div className="text-center py-5">Nessun'altra notifica</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </nav>
                    </header>
                    <ToastContainer
                        position="top-center"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme={theme === 'dark' ? 'dark' : 'light'}
                    />
                    <Outlet />
                </div>
            </div>
        </PrivateRoute>
    );
}

const mapStateToProps = ({ menu }) => {
    const { theme } = menu;
    return { theme };
};

export default connect(mapStateToProps, {})(LinearLayout);